import { useQuery, useMutation } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useReadContactPerson = () => {
  const { token } = useContext(AuthContext);

  return useQuery("contactPerson", async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile/contactPerson`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch contact person details");
    }

    return response.json();
  });
};

const useUpdateContactPerson = () => {
  const { token } = useContext(AuthContext);

  return useMutation(async (updatedFields) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile/update/contactPerson`, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedFields),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to update contact person");
    }

    return response.json();
  });
};

export { useReadContactPerson, useUpdateContactPerson };
